export const notificationKeys = {
  all: () => ['notifications'] as const,
  details: () => [...notificationKeys.all(), 'detail'] as const, // all single items we visit
  detail: (search: string, start: number) =>
    [...notificationKeys.details(), search, start] as const, // single item
  count: () => ['NOTIFICATIONS_COUNT'],
};
